import { render, staticRenderFns } from "./myIncome.vue?vue&type=template&id=42e24933&scoped=true&"
import script from "./myIncome.vue?vue&type=script&lang=js&"
export * from "./myIncome.vue?vue&type=script&lang=js&"
import style0 from "./myIncome.vue?vue&type=style&index=0&id=42e24933&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e24933",
  null
  
)

export default component.exports